import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Entry } from 'contentful';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-price-change-consent',
  templateUrl: './price-change-consent.component.html',
  styleUrls: ['./price-change-consent.component.scss']
})
export class PriceChangeConsentComponent implements OnInit {
  @Input() public globalContent: Entry<any> | undefined;
  @Input() public want: Observable<boolean>;

  @Output() goAhead = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit() {}

  giveConsent() {
    this.goAhead.emit(true);
  }
}
